import React from "react";
import Login from "./Login";
import CreateAccount from "./CreateAccount";
import { motion } from "framer-motion";
import t from "../../utilities/transitions";

class Form extends React.Component {
  constructor(props) {
    super();
    this.state = {
      submitSet: false,
    };
    this.form = props.form;
  }

  componentDidMount() {
    try {
      if (this.props.setSubmit) {
        this.submit = this.submit.bind(this);
        this.props.setSubmit(this.submit);
      }
    } catch (err) {
      console.log("Form LoginModal", err);
    }
  }

  render() {
    switch (this.form) {
      case "login":
        return (
          <motion.div
            className="pt-4"
            transition={t.transition}
            exit={t.fade_out_scale_1}
            animate={t.normalize}
            initial={t.fade_out}
          >
            <Login
              setSubmit={(click) => (this.submit = click)}
              modalShown={this.props.modalShown}
              setShowModal={this.props.setShowModal}
              toggleShowModal={this.props.toggleShowModal}
              setWorking={this.props.setWorking}
              notify={this.props.notify}
              emissions={this.props.emissions}
              profile={this.props.profile}
              flavor={this.props.flavor}
              setEmissions={this.props.setEmissions}
              setModalBodyHeight={this.props.setModalBodyHeight}
              changeForm={this.props.changeForm}
            />
          </motion.div>
        );
      case "create":
        return (
          <motion.div
            transition={t.transition}
            exit={t.fade_out_scale_1}
            animate={t.normalize}
            initial={t.fade_out}
          >
            <CreateAccount
              setSubmit={(click) => (this.submit = click)}
              modalShown={this.props.modalShown}
              setShowModal={this.props.setShowModal}
              toggleShowModal={this.props.toggleShowModal}
              setWorking={this.props.setWorking}
              notify={this.props.notify}
              setModalBodyHeight={this.props.setModalBodyHeight}
              emissions={this.props.emissions}
              profile={this.props.profile}
              flavor={this.props.flavor}
              setEmissions={this.props.setEmissions}
              changeForm={this.props.changeForm}
            />
          </motion.div>
        );
      default:
        console.log("oob form", this.form);
        return <></>;
    }
  }
}

export default Form;
